class SubServices extends Component
{
    constructor(el) {
        super(el);
        this.items = this.$findAll('.SubService-item');
        this.form = document.querySelector('.PageDetail-form');
        this.input = this.form.querySelector('input[id="product"]');
        this.prependText = document.querySelector('.SubpageHeader-title').innerHTML;
        this.addEventListeners();
    }

    addEventListeners() {
        this.items.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                let name = el.querySelector('.SubService-title').innerHTML;
                this.input.value = this.prependText + ' - ' + name;
                this.form.scrollIntoView();
            });
        });
    }
}